export default {"src":"/_next/static/media/heartpayroll-logo.8ccc626c.svg","height":72,"width":324};